import React from "react";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import HighchartMore from "highcharts/highcharts-more";
import { Alert } from "@mui/material";
import { Card, CardContent } from "@mui/material";
require("highcharts/modules/exporting")(Highcharts);
HighchartMore(Highcharts);
require("highcharts-grouped-categories")(Highcharts);

const ChartComponent = ({ options, className = "", callback, refrs }) => {
  if (options) {
    if (options.xAxis) options.xAxis.gridLineWidth = 0;
    if (options.yAxis) options.yAxis.gridLineWidth = 0;
    options.colors = ["#4D9DE0"];
  }

  // const [t] = useTranslation();

  return (
    
        <div id="chart-wrapper" className="chart-wrapper highChart-component">
          {options ? (
            <HighchartsReact
              highcharts={Highcharts}
              allowChartUpdate={true}
              containerProps={{ style: { width: "100%" } }}
              options={options}
              ref={refrs}
              callback={callback}
            />
          ) : (
            <Alert severity="warning" sx={{ textAlign: "center", my: 3 }}>
              Loading
            </Alert>
          )}
        </div>
     
  );
};

export default ChartComponent;
